import actions from './actions'
import mutations from './mutation'

const state = {
  spv_light_nodes_list: [],
  spv_light_nodes_paging: {
    offset: 0,
    limit: 10,
    total: 0
  }
}

export default {
  state,
  actions,
  mutations
}
